import { useLocation } from 'react-router-dom';

export interface IQuotationLineResolveParams {
  quotationId: string;
  lineId: string;
}

export const useQuotationLineResolveParams =
  (): IQuotationLineResolveParams | null => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const quotationId = queryParams.get('quotationId');
    const lineId = queryParams.get('lineId');

    if (!quotationId || !lineId) {
      return null;
    }
    return { quotationId, lineId };
  };
